import { EmptyView, ItemListContent } from "@eusoft/webapp-framework";
import { MaterialIcon } from "@eusoft/webapp-ui";
import { CreateCatalogPage } from "./EditCatalog";
import { navigatePage } from "../../actions";
import { entityItemsSource } from "../../helpers/ItemsSources";
import { context } from "../../services/Context";
import { executeAsync } from "../../services/DataService";
import type { ICatalogListView, IListCatalog } from "../../entities/Commands";

export interface IListCatalogArgs {
}


export const ListCatalogPage = ItemListContent.builder<ICatalogListView, IListCatalog>()

    .info({
        name: "catalog-list",
        route: "/catalog",
        icon: <MaterialIcon name="restaurant_menu" />,
    })

    .resource("ProductCatalog")

    .options(() => ({

        title: "catalog-list",
        style: ["panel", "round-item"],
        canOpen: true,
        canEdit: false,

        openItem: item => {
            navigatePage("edit-full-catalog", { catalogId: item.id })
        },

        itemAddContent: CreateCatalogPage.factory,

        itemsSource: entityItemsSource("ListCatalog"),

        prepareFilter: (filter, offset, limit) => ({
            ...filter,
            merchantId: context.merchant?.id
        }),

        confirmDeleteMessage: "msg-confirm-delete",

        deleteItemAsync: item => executeAsync("DeleteCatalog",
        {
            id: item.id,
            merchantId: context.merchant?.id
        }),

        pageSize: 50,

        emptyView: <EmptyView
            iconName="restaurant_menu"
            message="msg-no-catalog"
        />,

        columns: [{
            value: a => a.name,
            priority: "primary",
            header: "name",
        }],

        editMode: "page",

        filterMode: "tags"

    }))
    .asContent();